/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import Routes from './routes/routes';
import { AppProvider } from './lib/context';
import { initialState, reducer } from './lib/state';

const App =() => {
    return (
      <Router>
        <div className="App">
        <AppProvider initialState={initialState} reducer={reducer}>
          <Routes />
        </AppProvider>
        </div>
      </Router>
    );
  }

export default App;
